<template>
	<div>
		<v-data-table
			v-if="hasItens"
			v-model="itensAtaSelecionados"
			:headers="colunas"
			:items="itensAta"
			:show-select="temPermissaoEdicao"
			item-key="id"
			hide-default-footer
			:item-class="getItemClass"
			:server-items-length="totalItens"
			:options="paginacaoInterna"
			no-data-text="Nenhum item por aqui"
			class="arp-listview mt-5 row-pointer"
		>
			<template #[`header.data-table-select`]="{}">
				<v-simple-checkbox
					:value="itensAtaSelecionados.length === totalItens"
					:indeterminate="itensAtaSelecionados.length > 0 && itensAtaSelecionados.length < totalItens"
					color="primary"
					@input="onSelectAll($event)"
				></v-simple-checkbox>
			</template>
			<template #[`item.data-table-select`]="{ isSelected, select, item}">
				<v-simple-checkbox
					v-if="!estaCancelado(item)"
					id="caixaDeSelecaoAtaItens"
					class="row-checkbox"
					color="primary"
					:value="isSelected"
					@input="select($event)"
					@click.stop
				></v-simple-checkbox>
			</template>
			<template #item.identificacao="{ item }">
				<identificacao-ampla-cota :item="item"></identificacao-ampla-cota>
			</template>
			<template #item.tipo="{ item }">
				<div class="d-flex arp_icon_and_text">
					<texto-tooltip :texto="item.tipo" :tamanho-maximo="15"></texto-tooltip>
				</div>
			</template>
			<template #item.descricao="{ item }">
				<div class="d-flex arp_icon_and_text"  :class="{ 'text-decoration-line-through': estaCancelado(item)}"
				>
					<icone-tooltip
						v-if="item.isBloqueado"
						icone="mdi-cancel"
						cor="red"
						:texto="item.justificativaBloqueio"
						tamanho="16px"
					></icone-tooltip>
					<texto-tooltip :texto="item.descricao" :tamanho-maximo="textoTamanhoMaximo"></texto-tooltip>
				</div>
			</template>
			<template #item.unidadeAquisicao="{ item }">
				<span> {{ item.unidadeAquisicao }} </span>
			</template>
			<template #item.fornecedor="{ item }">
				<div>
					<v-tooltip color="black" bottom>
						<template #activator="{ on }">
							<v-icon
								v-show="item.hasFornecedoresAderentes"
								v-on="on"
								class="arp_icone_fornecedor"
								v-az-auth="permissoes.fornecedorItemAtaPrincipalComAderentesListar"
								@click="buscarFornecedores(item.id)"
								>mdi-account
							</v-icon>
						</template>
						{{ item.countFornecedoresAderentes }} fornecedores no cadastro reserva
					</v-tooltip>
					<v-tooltip bottom color="black" min-width="250">
						<template #activator="{ on }">
							<div class="primary--text" v-on="on">
								{{ item.fornecedor.razaoSocial }}

								<icone-tooltip
									v-if="item.possuiPenalidade"
									icone="mdi-alert"
									cor="grey"
									:texto="textoTooltipPenalidadeItem(item)"
									tamanho="16px"
								></icone-tooltip>
							</div>
						</template>
						<div>
							<v-row>
								<v-col cols="12">
									<h4>Fornecedor/Razão Social</h4>
									<div>{{ item.fornecedor.razaoSocial }}</div>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="6">
									<h4>Marca</h4>
									<div>{{ item.fornecedor.marca }}</div>
								</v-col>
								<v-col cols="6">
									<h4>Classificação</h4>
									<div>{{ item.fornecedor.classificacao }}&ordm; Lugar</div>
								</v-col>
							</v-row>
						</div>
					</v-tooltip>
				</div>
			</template>
			<template #item.valorUnitario="{ item }">
				<span> {{ item.valorUnitario | azCurrency(numeroCasasDecimaisValores) }} </span>
				<justificativa-icone
					v-if="!!item.justificativaRealinhamento"
					:justificativa="item.justificativaRealinhamento"
				></justificativa-icone>
			</template>
			<template #item.estoqueInicial="{ item }">
				<span class="pr-2" v-if="!(item.valorAcrescido || item.valorSuprimido)">
					{{ item.estoqueInicial | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}
				</span>
				<v-tooltip top color="black" v-if="item.valorAcrescido || item.valorSuprimido">
					<template #activator="{ on }">
						<div>
							<v-icon
								v-on="on"
								small
								color="orange"
							>mdi-alert</v-icon>
							<span class="pr-2">
									{{ (item.estoqueInicial + (item.valorAcrescido || 0) - (item.valorSuprimido || 0)) | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}
								</span>
						</div>
					</template>
					<div>
						<span>{{ 'Saldo Inicial: '}}{{ item.estoqueInicial | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}</span>
						<br v-if="item.valorAcrescido"/>
						<span v-if="item.valorAcrescido">{{ 'Acréscimo: ' }}{{ item.valorAcrescido | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}</span>
						<br v-if="item.valorSuprimido"/>
						<span v-if="item.valorSuprimido">{{ 'Supressão: '}}{{ (item.valorSuprimido * -1) | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}</span>
					</div>
				</v-tooltip>
			</template>
			<template #item.consumoAta="{ item }">
				<span class="pr-2">
					{{ item.consumoAta | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}
				</span>
			</template>
			<template #item.estoqueAtual="{ item }">
				<div class="estoque_atual">
					<span class="pr-2">
						{{ item.estoqueAtual | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}
					</span>
					<v-tooltip v-if="item.porcentagemAditar" variant="elevated" color="black" bottom>
						<template #activator="{ on }">
							<v-chip v-on="on" color="green" text-color="white" variant="elevated" x-small class="px-1">
								+{{ item.porcentagemAditar }}%
							</v-chip>
						</template>
						Aditado em {{ item.porcentagemAditar }}%
					</v-tooltip>
				</div>
			</template>
			<template #item.saldoInicialAdesao="{ item }">
				<span class="pr-2">
					{{ item.saldoInicialAdesao | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}
				</span>
			</template>
			<template #item.consumoAdesao="{ item }">
				<span class="pr-2">
					{{ item.consumoAdesao | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}
				</span>
			</template>
			<template #item.saldoAtualAdesao="{ item }">
				<span class="pr-2">
					{{ item.saldoAtualAdesao | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}
				</span>
			</template>
			<template #header.prazoEntrega="{ header }">
				<label-personalizado
					class="d-inline mr-1"
					:nome-campo="header.text"
					:obrigatorio-por-padrao="prazoEntregaObrigatorio"
				></label-personalizado>
				<icone-tooltip
					icone="mdi-information-outline"
					cor="grey"
					:texto="textoTooltipColunaPrazoEntrega"
					tamanho="16px"
				></icone-tooltip>
			</template>
			<template #item.prazoEntrega="{ item }">
				<div class="d-flex" id="itens-ata-campo-prazo-entrega">
					<v-text-field
						v-model="item.dias"
						type="number"
						dense
						hide-spin-buttons
						placeholder="Dias"
						:rules="numeroDiasRules"
						@keydown="validarSeInputIsNumerico($event)"
						@input="lidarComSalvamentoAutomatico(item)"
						:disabled="!mostrarCamposPrazoEntrega || estaCancelado(item)"
					>
					</v-text-field>
					<v-autocomplete
						v-model="item.tipoDias"
						:items="tipoDias"
						placeholder="Tipo de dias"
						item-value="value"
						item-text="text"
						dense
						clearable
						@input="lidarComSalvamentoAutomatico(item)"
						:disabled="!mostrarCamposPrazoEntrega || estaCancelado(item)"
					>
					</v-autocomplete>
				</div>
			</template>
			<template #item.acoes="{ item }">
				<acessar-ata-itens-btn-acoes
					v-if="!estaCancelado(item)"
					:is-item-bloqueado="item.isBloqueado"
					:item="item"
					@realinhar="$emit('realinhar', item)"
					@bloquear="$emit('bloquear', item)"
					@aditar="$emit('aditar-item', item)"
					@alterar-classificacao="$emit('alterar-classificacao', item)"
					@alterar-fornecedor="$emit('alterar-fornecedor', item)"
					@gerenciar-estoque="$emit('gerenciar-estoque', item)"
					@excluir="$emit('excluir-item', item)"
				></acessar-ata-itens-btn-acoes>
			</template>
		</v-data-table>

		<template-listagem-vazia
			:total-itens="totalItens"
			:textos="textosDoTemplateDaListagemVazia"
		></template-listagem-vazia>

		<paginacao-tabela
			v-if="totalItens > 0"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			:totalPaginas="totalPaginas"
			:totalItens="totalItens"
			@resetar-page="resetarPage"
		></paginacao-tabela>
	</div>
</template>

<script>
import AcessarAtaItensBtnAcoes from '@/views/pages/ata/acessar/gestao-da-ata/itens/listagem/botoes-acoes-listagem/AcessarAtaItensBtnAcoes.vue'
import { TabelaColunaUtils } from '@/core/utils'
import { tipoDias, mutationTypes, actionTypes } from '@/core/constants'
import tabelaMixin from '@/views/mixins/tabela'
import validacaoAta from '@/views/mixins/validacaoAta'
import { mapState } from 'vuex'
import IdentificacaoAmplaCota from '@/views/components/IdentificacaoAmplaCota.vue'

export default {
	name: 'acessar-ata-itens-listagem',
	components: { IdentificacaoAmplaCota, AcessarAtaItensBtnAcoes },
	mixins: [tabelaMixin, validacaoAta],
	props: {
		itensAta: {
			type: Array,
			required: true,
		},
		informacoesAta: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			textosDoTemplateDaListagemVazia: {
				titulo: 'Nenhum item de ata por aqui',
			},
			paginacaoInterna: this.paginacao,
			textoTamanhoMaximo: 30,
			textoTooltipColunaPrazoEntrega: 'Informe n° de 1 a 365 em "Dias"',
			salvamentoTimeout: {},
			timeoutAutosave: 1500,
			numeroDiasRules: [(v) => this.validarMinMax(v)],
			mostrarCamposPrazoEntrega: false,
		}
	},
	computed: {
		...mapState({
			prazoEntregaObrigatorio: (state) => state.parametrosSistema.prazoEntregaObrigatorio,
		}),
		tipoDias() {
			return Object.values(tipoDias)
		},
		numeroCasasDecimaisQtde: {
			get() {
				return this.$store.state.ata.informacoesAta.numeroCasasDecimaisQtde
			},
		},
		numeroCasasDecimaisValores: {
			get() {
				return this.$store.state.ata.informacoesAta.numeroCasasDecimaisValores
			},
		},
		itensAtaSelecionados: {
			get() {
				return this.$store.state.itemAta.itensAtaSelecionados
			},
			set(item) {
				this.$store.commit(mutationTypes.ITEM_ATA.ITEM_ATA_SELECIONADO, item)
			},
		},
		isSelecionouTodosItensDaAta: {
			get() {
				return this.$store.state.itemAta.isSelecionouTodosItensDaAta
			},
		},
		colunas() {
			const cols = [
				new TabelaColunaUtils('', 'identificacao', '1%'),
				new TabelaColunaUtils('Tipo', 'tipo', '3%'),
				new TabelaColunaUtils('Seq', 'item', '3%'),
				new TabelaColunaUtils('Descrição', 'descricao', '16%'),
				new TabelaColunaUtils('Unid. Aquisição', 'unidadeAquisicao', '7%'),
				new TabelaColunaUtils('Fornecedores', 'fornecedor', '11%'),
				new TabelaColunaUtils('Valor unitário', 'valorUnitario', '8%'),
				new TabelaColunaUtils('Saldo Inicial Ata', 'estoqueInicial', '7%'),
				new TabelaColunaUtils('Consumo Ata', 'consumoAta', '6%'),
				new TabelaColunaUtils('Saldo Atual Ata', 'estoqueAtual', '7%'),
				new TabelaColunaUtils('Saldo Inicial Adesão', 'saldoInicialAdesao', '7%'),
				new TabelaColunaUtils('Consumo Adesão', 'consumoAdesao', '7%'),
				new TabelaColunaUtils('Saldo Atual Adesão', 'saldoAtualAdesao', '7%'),
				new TabelaColunaUtils('Prazo de Entrega', 'prazoEntrega', '10%'),
			]

			if (!this.isAtaAdesao) {
				cols.push(new TabelaColunaUtils('Ações', 'acoes', '5%'))
			}

			return cols
		},
	},
	mounted() {
		this.mostrarCamposPrazoEntrega = this.informacoesAta.usuarioPermissaoAlterar
	},
	async beforeDestroy() {
		this.$store.commit(mutationTypes.ITEM_ATA.LIMPAR_HISTORICOS)
		await this.salvarPrazoEntregaPendentes()
	},
	methods: {
		resetarPage() {
			this.$emit('resetar-page')
		},
		buscarFornecedores(id) {
			this.$store.commit(mutationTypes.FORNECEDOR_ITEM_ATA.SET_ID_ITEM_BUSCAR_FORNECEDORES, id)
			this.$emit('vizualizar-fornecedores')
		},
		onSelectAll(value) {
			if (value && !this.isSelecionouTodosItensDaAta) {
				this.$store.commit(mutationTypes.ITEM_ATA.SET_IS_SELECIONOU_TODOS_ITENS)
				this.itensAtaSelecionados = this.itensAta
			} else {
				this.$store.commit(mutationTypes.ITEM_ATA.UNSET_IS_SELECIONOU_TODOS_ITENS)
				this.itensAtaSelecionados = []
			}
		},
		textoTooltipPenalidadeItem(item) {
			return `Sanção ${item.tipoPenalidade}`
		},
		lidarComSalvamentoAutomatico(item) {
			const itemId = item.id
			if (this.salvamentoTimeout[itemId]) clearTimeout(this.salvamentoTimeout[itemId])

			this.salvamentoTimeout[itemId] = setTimeout(
				async () => await this.salvarPrazoEntrega(item),
				this.timeoutAutosave,
			)
		},
		async salvarPrazoEntrega(item) {
			await this.$store
				.dispatch(actionTypes.ITEM_ATA.SALVAR_INFORMACOES_PRAZO_ENTREGA, this.montarObjSalvarPrazoEntrega(item))
				.then(() => {
					item._dias = item.dias
					item._tipoDias = item.tipoDias
				})
				.catch(() => {
					item.dias = item._dias
					item.tipoDias = item._tipoDias
				})
				.finally(() => delete this.salvamentoTimeout[item.id])
		},
		montarObjSalvarPrazoEntrega(item) {
			return {
				idsItens: [item.id],
				dias: item.dias,
				tipoDias: item.tipoDias,
				isAlteracaoEmMassa: false,
			}
		},
		validarSeInputIsNumerico(evento) {
			const inputsInvalidos = ['e', '.', ',']
			const key = evento.key

			if (
				(!/^[0-9]$/.test(key) && !['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(key)) ||
				inputsInvalidos.some((keyInvalida) => evento.key === keyInvalida)
			) {
				evento.preventDefault()
			}
		},
		validarMinMax(valor) {
			return !valor || !(valor < 1 || valor > 365)
		},
		async salvarPrazoEntregaPendentes() {
			const promessas = Object.keys(this.salvamentoTimeout).map((itemId) => {
				clearTimeout(this.salvamentoTimeout[itemId])
				const itemModificado = this.itensAta.find((_item) => itemId === _item.id.toString())
				return this.salvarPrazoEntrega(itemModificado)
			})

			await Promise.all(promessas)
		},
		getItemClass(item) {
			if (this.estaCancelado(item)) {
				return 'linha-cancelada'
			}
			return ''
		},
		estaCancelado(item) {
			return !!item?.isCancelado
		}

	},
}
</script>
<style lang="stylus">
.arp_icon_and_text
	> i
		margin-right 2px

.linha-cancelada
	background-color: #f5f5f5 !important;
	color: #9e9e9e !important;

.linha-cancelada td
	color: #9e9e9e !important;


.arp_icone_fornecedor
	background-color: transparent;
	border-radius: 50%;
	padding: 2px 2px;
	color: #0067a5;
	float: left;
	margin-right: 5px;
	font-size: 15px !important;

.estoque_atual
	display: flex;
	justify-content: flex-start;
	align-items: center;

#itens-ata-campo-prazo-entrega
	gap 15px !important
	align-items center !important

	> *:first-child
		width 35% !important

	.v-autocomplete.v-select.v-input--is-focused input
		min-width: 0 !important

	.v-input__append-inner
		width 24px !important
		height 24px !important

	@media screen and (min-width: 750px)
		min-width 190px !important
</style>
